export default __webpack_public_path__ + "static/media/reducing-screen-flip.a683c0c0.svg";